import { AccountTypeFeePeriod } from '@/types/api/account';

export const ACCOUNT_TYPE_PERIOD_TEXT = {
  [AccountTypeFeePeriod.Monthly]: 'accountTypePeriod.month',
  [AccountTypeFeePeriod.Withdraw]: 'accountTypePeriod.withdrawal',
};

export const ACCOUNT_TYPE = {
  CHQ: 'CHQ', // e-Free account
};
